import { createAction } from "@reduxjs/toolkit";

export const updateDirections = createAction('updateDirections');
export const updateRoutes = createAction('updateRoutes');
export const updateSummary = createAction('updateSummary');
export const updateStartingPoint = createAction('updateStartingPoint');
export const updateFinishingPoint = createAction('updateFinishingPoint');
export const updateStartAddress = createAction('updateStartAddress');
export const updateFinishAddress = createAction('updateFinishAddress');
export const updateCustomEndPoint = createAction('updateCustomEndPoint');